import { useContext } from 'react';
import { OrganizationConfigContext } from '../context/OrganizationConfigContext';
import { FragmentType, getFragmentData, graphql } from 'client/gql';

const UseGroupMembersCountFragmentDocument = graphql(`
  fragment UseGroupMembersCountFields on Query {
    groupMembersCount: groups(where: { uuid: $groupUuid }) {
      uuid
      __typename
      editorsAggregate {
        __typename
        count
      }
      viewersAggregate {
        __typename
        count
      }
      organization {
        uuid
        __typename
      }
    }
  }
`);

export const useGroupMembersCount = (query: FragmentType<typeof UseGroupMembersCountFragmentDocument> | undefined) => {
  const { organization } = useContext(OrganizationConfigContext);
  const fragment = getFragmentData(UseGroupMembersCountFragmentDocument, query);

  const group = fragment?.groupMembersCount[0];

  const groupMembers = (group?.editorsAggregate?.count ?? 0) + (group?.viewersAggregate?.count ?? 0);

  const organizationUuid = group?.organization?.uuid ?? organization?.uuid ?? '';

  return {
    groupMembers,
    organizationUuid,
  };
};
